module.exports = __webpack_public_path__ + "img/history_gallery_4.39ed3245.png";